export type WorkType = "movie" | "tv" | "variety";

export interface Work {
  id: string;
  title: string;
  type: WorkType;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  popularity: number;
  duration: string;
  director: string;
  cast: string[];
  poster: string;
  backdrop: string;
  synopsis: string;
  tags: string[];
}

export interface NewsItem {
  id: string;
  title: string;
  category: WorkType;
  date: string;
  summary: string;
  cover: string;
  content: string[];
  tags: string[];
}

export const TYPE_LABELS: Record<WorkType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const TYPE_PATHS: Record<WorkType, string> = {
  movie: "/category/movie",
  tv: "/category/tv",
  variety: "/category/variety",
};